import {
  Typography,
  Box,
  Grid,
  useTheme,
  Container,
  Button,
  Stack,
} from "@mui/material";
import { Link } from "react-router-dom";
import EmailIcon from '@mui/icons-material/Email';

function Footer() {
  const theme = useTheme();

  // Common text styles
  const commonTextStyle = {
    color: "#6b6b6b",
    textDecoration: "none",
    fontFamily: "'Inter', sans-serif",
    fontSize: { xs: "12px", sm: "13px", md: "14px" },
    lineHeight: 1.6,
  };

  const linkStyle = {
    ...commonTextStyle,
    transition: "color 0.3s ease",
    "&:hover": { 
      color: theme.palette.primary.main,
      textDecoration: "underline" 
    },
  };

  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: "#D2E6E4",
        pt: { xs: 3, md: 4 },
        pb: { xs: 2, md: 3 },
        px: { xs: 2, sm: 4 },
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          {/* Left Section - Brand Info */}
          <Grid item xs={12} md={7}>
            <Stack spacing={2}>
              {/* Brand Logo and Name */}
              <Box display="flex" alignItems="center">
                <Box
                  component="img"
                  src={require("./3.png")}
                  height={50}
                  width={50}
                  alt="AnyPaper Logo"
                  sx={{ mr: 1.5 }}
                />
                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: 600,
                    color: "#0B3953",
                    fontSize: { xs: "20px", md: "22px" },
                  }}
                >
                  ANY PAPER
                </Typography>
              </Box>

              {/* Description */}
              <Box>
                <Typography variant="body2" sx={{ ...commonTextStyle, mb: 1 }}>
                  Please use our service if you are:
                </Typography>
                <Box component="ul" sx={{ 
                  pl: 2.5,
                  mb: 1.5,
                  "& li": {
                    ...commonTextStyle,
                    mb: 0.5,
                  }
                }}>
                  <li>Seeking unique insights into a subject matter for research</li>
                  <li>Looking to expand your knowledge on a topic</li>
                  <li>Needing assistance with formatting citations</li>
                  <li>Requiring help with paraphrasing and managing plagiarism</li>
                  <li>Interested in proofreading based on educational guidelines</li>
                </Box>
                <Typography variant="body2" sx={commonTextStyle}>
                  All of the papers at AnyPaper are meant for research purposes only
                  and should not be submitted for academic credit.
                </Typography>
              </Box>

              {/* Email Subscription */}
              <Box sx={{ mt: 1 }}>
                <Typography variant="body2" sx={{ 
                  ...commonTextStyle,
                  mb: 1,
                  fontWeight: 500 
                }}>
                  Subscribe to our newsletter
                </Typography>
                <Box
                  sx={{
                    display: "flex",
                    maxWidth: "500px",
                    width: "100%",
                  }}
                >
                  <input
                    type="email"
                    placeholder="Your Email"
                    aria-label="Email subscription input"
                    style={{
                      flex: 1,
                      border: "none",
                      outline: "none",
                      padding: "12px 16px",
                      fontSize: "14px",
                      fontFamily: "'Inter', sans-serif",
                      borderRadius: "4px 0 0 4px",
                    }}
                  />
                  <Button
                    variant="contained"
                    sx={{
                      backgroundColor: "#FFB300",
                      borderRadius: "0 4px 4px 0",
                      px: 3,
                      "&:hover": {
                        backgroundColor: "#FFA000",
                      },
                    }}
                  >
                    <Typography
                      sx={{
                        textTransform: "none",
                        color: "#fff",
                        fontSize: "14px",
                        fontWeight: 500,
                      }}
                    >
                      Subscribe
                    </Typography>
                  </Button>
                </Box>
              </Box>            </Stack>
          </Grid>

          {/* Right Section - Links and Gallery */}
          <Grid item xs={12} md={5}>
            <Grid container spacing={4}>
              {/* Links Section */}
              <Grid item xs={12} sm={6} md={12} lg={6}>
                <Box>
                  <Typography
                    variant="h6"
                    sx={{
                      fontWeight: 600,
                      mb: 2,
                      fontSize: "16px",
                      color: "#0B3953",
                    }}
                  >
                    FAQs & Policies
                  </Typography>
                  <Stack spacing={1}>
                    <Link to="/refundpolicy" style={{ textDecoration: "none" }}>
                      <Typography sx={linkStyle}>Refund Policy</Typography>
                    </Link>
                    <Link to="/termsandconditions" style={{ textDecoration: "none" }}>
                      <Typography sx={linkStyle}>Terms & Conditions</Typography>
                    </Link>
                    <Link to="/privacypolicy" style={{ textDecoration: "none" }}>
                      <Typography sx={linkStyle}>Privacy Policy</Typography>
                    </Link>
                    <Link to="/cookiepolicy" style={{ textDecoration: "none" }}>
                      <Typography sx={linkStyle}>Cookie Policy</Typography>
                    </Link>
                  
  <Typography
    component="span"
    sx={{
      color: "grey",
      fontSize: "16px",
      fontWeight: 500,
      fontFamily: "'Inter', sans-serif",
    }}
  >
    contact us:
  </Typography>
                    <Link 
  href="mailto:contact@anypaperpro.com" 
  sx={{ 
    textDecoration: "none",
    display: "inline-flex",
    alignItems: "center",
    gap: 0.5,
  }}
>

  <Typography
    component="span"
    sx={{
      color: "#0B3953",
      fontSize: "15px",
      fontWeight: 500,
      fontFamily: "'Inter', sans-serif",
    }}
  >
    contact@anypaperpro.com
  </Typography>
</Link>



                  </Stack>
                </Box>
              </Grid>

              {/* Image Gallery - Desktop */}
              <Grid item xs={12} sm={6} md={12} lg={6}>
                <Box
                  sx={{
                    display: { xs: "flex", md: "flex" },
                    justifyContent: { xs:"center",md: "flex-end", lg: "center" },
                    gap: 2,
                    flexWrap: "wrap",
                  }}
                >
                  <Box
                    component="img"
                    src="/1.png"
                    alt="Gallery image 1"
                    sx={{
                      height: 80,
                      width: 80,
                      borderRadius: 2,
                      objectFit: "cover",
                    }}
                  />
                  <Box
                    component="img"
                    src="/2.png"
                    alt="Gallery image 2"
                    sx={{
                      height: 80,
                      width: 80,
                      borderRadius: 2,
                      objectFit: "cover",
                    }}
                  />
<Box sx={{
  position: 'relative',
  width: { xs: 180, md: 220 },
  mt: 2
}}>
  {/* "We accept" text - always visible */}
  <Typography 
    variant="body1"
    sx={{
      position: 'absolute',
      top: '-10px',
      left: '1px',
      fontWeight: 600,
      color: "#0B3953",
      fontSize: { xs: "14px", md: "16px" },
      backgroundColor: '#D2E6E4',
      px: 1,
      py: 0.5,
      borderRadius: '4px',
      zIndex: 1,
    }}
  >
    We accept:
  </Typography>

  {/* Payment methods image */}
  <Box
    component="img"
    src="/3.png"
    alt="Payment methods"
    sx={{
      height: { xs: 100, md: 120 },
      width: '100%',
      borderRadius: 1,
      objectFit: "cover",
    }}
  />
</Box>
</Box>

              </Grid>
            </Grid>
          </Grid>
        </Grid>

        {/* Copyright Section */}
        <Box
          sx={{
            mt: 4,
            pt: 2,
            borderTop: "1px solid rgba(0,0,0,0.1)",
            textAlign: "center",
          }}
        >
          <Typography
            variant="body2"
            sx={{
              color: "#2D2E2E",
              fontSize: { xs: "11px", sm: "12px" },
              fontFamily: "'Inter', sans-serif",
            }}
          >
            This website is owned and operated by SKM Educational Media Ltd.<br />
            Piliou 11-13, Quality Towers A, office 201, 6037, Larnaca, Cyprus
          </Typography>
        </Box>
      </Container>
    </Box>
  );
}

export default Footer;